import {z} from 'zod';
import {creativeCardSchema} from '../../../../../schemas/creativeCardSchema';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {LandingPageSource} from 'common/src/modules/campaigns/campaigns.enums';
import {DTCreativeNode} from 'common/src/modules/decisionTree/decisionTree.types';

export function convertCreativeAPICardToAICard(
  creativeCard: DTCreativeNode,
): z.output<typeof creativeCardSchema> {
  const candidate: z.input<typeof creativeCardSchema> = {
    cardId: creativeCard.id,
    name: creativeCard.name ?? `Creative #${creativeCard.id}`,
    description: creativeCard.description ?? '',
    type: NodeType.CREATIVE,
    creativeId: creativeCard.creativeId,
    landingPageSource: creativeCard.landingPageSource ?? LandingPageSource.Campaign,
    isFallback: creativeCard.isFallbackCreative ?? false,
  } satisfies z.output<typeof creativeCardSchema>;

  return candidate;
}
